import styles from './PageSectionTitle.module.scss'
import { classNames } from '@/src/helpers/component'
import { PageSectionTitleProps } from './PageSectionTitle.types'
import CTAButton from '@/src/components/common/CTAButton'

export default function PageSectionTitleClient(_: PageSectionTitleProps) {
  if (!_.header && !_.text) return null
  return (
    <div
      className={classNames(
        styles.container,
        _.className,
        _.align == 'left' || _.cta ? styles.left : styles.center,
      )}>
      <div className={styles.headings}>
        <h3 className={styles.header}>{_.header}</h3>
        <div className={styles.text}>{_.text}</div>
      </div>
      {_.cta && <CTAButton {..._.cta} className={classNames(styles.cta, _.cta.className)} />}
    </div>
  )
}
